import { useContext } from 'react';
import { StoresContext } from '../../../../App';
import EngineeringFilterSection from './engineering-filter-section';

export default function EngineeringFilterContainer() {
    const {
        featureFilters,
        setFeatureSearch,
        activeFilter,
        setActiveFilter,
        setFeatureFilters,
    } = useContext(StoresContext);

    const engineeringOnlyFilters = featureFilters.filter((item) => item.code.startsWith('ENG'));

    const selectedById: Record<string, boolean> = engineeringOnlyFilters.reduce(
        (acc, item) => ({
            ...acc,
            [item.code]: true,
        }),
        {}
    );

    const toggleEngineeringFeature = (featureId: string) => {
        const isSelected = !!selectedById[featureId];
        const nextFilters = isSelected
            ? engineeringOnlyFilters.filter((item) => item.code !== featureId)
            : [...engineeringOnlyFilters, { code: featureId, value: '_any_' }];

        // Reset distributor filter to avoid conflicting empty results.
        setFeatureSearch([]);
        setFeatureFilters(nextFilters);

        if (nextFilters.length) {
            setActiveFilter('engineering');
        } else if (activeFilter === 'engineering') {
            setActiveFilter(null);
        }
    };

    return (
        <div className="feature-filter-block destributors-filter-block">
            <EngineeringFilterSection
                onToggleFeature={toggleEngineeringFeature}
                selectedById={selectedById}
            />
        </div>
    );
}
